import Ads from "../components/Ads";
import React, { useContext, useEffect } from "react";
import ContainerFeaturedItems from "../components/Containers/ContainerFeaturedItems";
import Process from "../components/Process/Process";
import { DataHomeQuestions } from "../components/FAQs/Data";
import Questions from "../components/FAQs/Questions";
import ExperienceCard from "../components/ExperienceCard/ExperienceCard";
import TopBar from "../components/TopBar";
import Hero from "../components/Hero/Hero";
import Discover from "../components/Discover/Discover";
import FlowCards from "../components/FlowCards/FlowCards";
import { ProductContext } from "../Context/products_context";
import Footerr from "../components/Footerr/Footerr";
import $ from "jquery";
import ProgressBar from "../components/ProgressBar";

function Home() {
  const productss = useContext(ProductContext);

  useEffect(() => {
    $(window).on("scroll", function () {
      $(window).scrollTop()
        ? $(".trending-div").addClass("scrolled-div")
        : $(".trending-div").removeClass("scrolled-div");
    });
  }, []);

  return (
    <div>
      <ProgressBar />
      <TopBar />
      <Hero />
      <div className="pattern-bg2">
        <div className="container a-container a-padding">
          <Ads />
          <FlowCards />
        </div>
      </div>
      <ContainerFeaturedItems data={productss} />
      <ExperienceCard />
      <Process />
      <Discover />
      <Questions data={DataHomeQuestions} />
      <Footerr />
    </div>
  );
}

export default Home;
